import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Coins, Lock } from "lucide-react";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Membership() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/membership").then((r) => setData(r.data)).catch((e) => toast.error(errorMessage(e))); }, []);
  const checkout = async (id) => { try { await api.post(`/membership/checkout/${id}`); } catch (e) { toast.error(errorMessage(e)); } };
  if (!data) return <div className="h-64 rounded-2xl shimmer" />;
  const total = data.credits + data.spent;
  return (
    <div className="space-y-8 rise" data-testid="membership-page">
      <div><span className="overline-label">Membership</span><h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Plans & credits</h1></div>
      <div className="grid lg:grid-cols-12 gap-6">
        <div className="lg:col-span-4 card-surface p-6 space-y-4" data-testid="credits-panel">
          <div className="flex items-center gap-2 text-primary"><Coins size={18} /><span className="overline-label text-primary">Credit balance</span></div>
          <p className="text-5xl font-display font-bold tracking-tighter" data-testid="credits-value">{data.credits}</p>
          <div className="h-2 rounded-full bg-muted overflow-hidden"><div className="h-full bg-primary" style={{ width: `${total ? Math.round((data.credits / total) * 100) : 0}%` }} /></div>
          <p className="text-xs text-muted-foreground font-mono">{data.spent} spent · 1 credit = 1 rendered variation · plan: {data.plan}</p>
          {!data.revenuecat.configured && (
            <p className="flex items-start gap-2 text-xs text-amber-500" data-testid="revenuecat-notice"><Lock size={13} className="mt-0.5 shrink-0" /> RevenueCat isn't connected yet. Purchases activate once the project configuration (API keys + webhook secret) is supplied.</p>
          )}
        </div>
        <div className="lg:col-span-8 grid sm:grid-cols-3 gap-4">
          {data.plans.map((p, i) => (
            <div key={p.id} className={`card-surface card-hover p-5 flex flex-col ${i === 1 ? "border-primary/60" : ""}`} data-testid={`plan-${p.id}`}>
              {i === 1 && <span className="overline-label text-primary mb-2">Most popular</span>}
              <p className="font-display font-semibold text-lg">{p.name}</p>
              <p className="text-2xl font-display font-bold tracking-tight mt-1">{p.price}</p>
              <ul className="text-sm text-muted-foreground space-y-1.5 my-4 flex-1">{p.features.map((f) => <li key={f} className="flex gap-2"><Check size={14} className="text-primary shrink-0 mt-0.5" /> {f}</li>)}</ul>
              <Button onClick={() => checkout(p.id)} variant={i === 1 ? "default" : "outline"} className="btn-pill w-full" data-testid={`plan-checkout-${p.id}`}>{data.revenuecat.configured ? "Subscribe" : "Awaiting RevenueCat"}</Button>
            </div>
          ))}
        </div>
      </div>
      <div className="card-surface p-6" data-testid="ledger">
        <span className="overline-label">Credit ledger</span>
        <div className="divide-y divide-border mt-3">
          {data.ledger.map((l) => (
            <div key={l.id} className="flex items-center justify-between py-2.5 text-sm" data-testid={`ledger-item-${l.id}`}>
              <div><p>{l.reason}</p><p className="text-xs text-muted-foreground font-mono">{new Date(l.created_at).toLocaleString()}</p></div>
              <span className={`font-mono font-semibold ${l.delta > 0 ? "text-primary" : "text-foreground"}`}>{l.delta > 0 ? "+" : ""}{l.delta}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
